export default __webpack_public_path__ + "static/media/dropdown-icon.efe703cd.svg";